<div 
  class="banner-badge"
  [ngClass]="[sizeClass, typeClass, animatedClass]"
  [class.banner-badge--disabled]="disabled"
  [class.banner-badge--hidden]="!value"
  [ngStyle]="dynamicStyles"
  role="button" 
  tabindex="0"
  [attr.aria-label]="'Badge ' + displayValue"
  [title]="'Badge ' + displayValue"
  (click)="onBadgeClick()"
  (keydown.enter)="onBadgeClick()"
  (keydown.space)="onBadgeClick()">
  
  <!-- Circular badge for discount -->
  <div class="banner-badge__circular-badge">
    {{ displayValue }}
  </div>
  
  <!-- Main rectangle content -->
  <div class="banner-badge__main-content">
    <span class="banner-badge__label">{{ label }}</span>
    <span class="banner-badge__amount">{{ amount }}</span>
  </div>
</div>
